import {useContext} from 'react';
import {useParams, useRouteMatch} from 'react-router-dom';
import {UserCardsAssociations} from '../../../../../../../components/user-cards-associations/user-cards-associations';
import {OfficeContext} from '../../../../../../../contexts/office/context';
import {OfficeContextType} from '../../../../../../../contexts/office/types';
import {ScreenPaths} from '../../../../../../../enums/screen-path';
import {CaregiverMode} from '../../../../../../../enums';

export default function SeniorUserCardsSystemAdministratorOfficeScreen() {
  // Get params
  let {id}: {id?: string} = useParams();

  // Get context
  const officeContext: OfficeContextType = useContext(OfficeContext);

  // The `path` lets us build <Route> paths that are
  // relative to the parent route, while the `url` lets
  // us build relative links.
  let {url} = useRouteMatch();

  return (
    <UserCardsAssociations
      caregiverMode={CaregiverMode.SystemAdministrator}
      canWrite
      userId={id || ''}
      userName={officeContext.state.userForm?.user.name || ''}
      associateCardUrl={url.charAt(url.length - 1) === '/' ? `${url}associate` : `${url}/associate`}
      cardRowBaseLinkUrl={`${ScreenPaths.Office}${ScreenPaths.Office_SystemAdministrator}${ScreenPaths.SystemAdministrator_UserCards}`}
    />
  );
}
